module.exports = __webpack_public_path__ + "static/img/PT.c81d247f.svg";